import React, { useState } from 'react';
import { PlusIcon } from '../icons';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from './FAQAccordion.module.css';

const ToggleIcon = ({ expanded }) => (
  <PlusIcon
    className={expanded ? css.iconExpanded : css.iconWrap}
    size={20}
    aria-hidden="true"
  />
);

const FAQAccordion = ({ questions = [], currentLanguage = 'de' }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  if (!questions?.length) {
    return null;
  }

  const handleToggle = index => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section className={css.section} data-elbaction="visible:vis faq">
      <h2 className={css.title}>
        <FormattedMessage id="FAQAccordion.title" />
      </h2>

      <div className={css.list}>
        {questions.map((question, index) => {
          const isExpanded = expandedIndex === index;
          const questionText =
            currentLanguage === 'de' ? question.question_de || question.question : question.question;
          const answerText =
            currentLanguage === 'de' ? question.answer_de || question.answer : question.answer;

          return (
            <div key={index} className={css.item}>
              <button
                type="button"
                className={css.questionBtn}
                onClick={() => handleToggle(index)}
                aria-expanded={isExpanded}
              >
                <span>{questionText}</span>
                <ToggleIcon expanded={isExpanded} />
              </button>
              {isExpanded && answerText && <div className={css.answer}>{answerText}</div>}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FAQAccordion;
